import { db } from '../firebase';
import { 
  collection, 
  doc,
  addDoc,
  getDocs,
  updateDoc,
  query,
  where,
  orderBy,
  serverTimestamp 
} from 'firebase/firestore';

export const habitService = {
  async createHabit(userId, name) {
    try {
      const habitsRef = collection(db, 'habits');
      const habitData = {
        userId,
        name,
        createdAt: serverTimestamp(),
        completedDates: [],
        streak: 0
      };
      
      await addDoc(habitsRef, habitData);
    } catch (error) {
      console.error('Error creating habit:', error);
      throw error;
    }
  },

  async getHabits(userId) {
    try {
      const habitsRef = collection(db, 'habits');
      const q = query(
        habitsRef,
        where('userId', '==', userId),
        orderBy('createdAt', 'desc')
      );
      
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error getting habits:', error);
      throw error;
    }
  },

  async toggleHabitCompletion(userId, habitId, date) {
    try {
      const habitRef = doc(db, 'habits', habitId);
      const habit = (await getDocs(query(
        collection(db, 'habits'),
        where('userId', '==', userId)
      ))).docs.find(doc => doc.id === habitId);

      if (!habit) throw new Error('Habit not found');

      const habitData = habit.data();
      const dateStr = date.toISOString();
      let completedDates = habitData.completedDates || [];
      let streak = habitData.streak || 0;

      if (completedDates.includes(dateStr)) {
        completedDates = completedDates.filter(d => d !== dateStr);
        streak = Math.max(0, streak - 1);
      } else {
        completedDates.push(dateStr);
        streak = streak + 1;
      }

      await updateDoc(habitRef, {
        completedDates,
        streak
      });
    } catch (error) {
      console.error('Error toggling habit completion:', error);
      throw error;
    }
  }
}; 